// @flow

import styled from 'styled-components';
import PropTypes from 'prop-types';

import DisplayText from '../Text/DisplayText';

import { PIN_PAD_WIDTH } from './constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-height: ${props => 45 * props.scale}px;
`;

const Separator = styled.div`
  background-color: ${props => props.theme.btnBrand};
  height: 4px;
  border-radius: 2px;
  margin-top: 10px;
  width: ${props => PIN_PAD_WIDTH * props.scale}px;
`;

const TextContainer = styled.div`
  height: ${props => 40 * props.scale}px;
`;

type Props = {
  pin: string,
  scale: number
};

export default function PinDisplay({ pin, scale }: Props) {
  const hiddenPin = pin.replace(/./g, '•');
  const lineHeight = 40 * scale + 'px';

  return (
    <Container scale={scale}>
      <TextContainer scale={scale}>
        <DisplayText fontSize="30px" bold letterSpacing="15px" lineHeight={lineHeight}>
          {hiddenPin}
        </DisplayText>
      </TextContainer>
      <Separator scale={scale} />
    </Container>
  );
}

PinDisplay.propTypes = {
  pin: PropTypes.string,
  scale: PropTypes.number
};
